<template>
  <div class="token-body">
    <el-form
      :model="tokenForm"
      :rules="tokenRules"
      ref="ruleForm"
      label-width="100px"
      label-position="top"
      class="token-form"
    >
      <el-form-item>
        <div class="token-title">实时GAS</div>
      </el-form-item>

      <el-form-item label="公链" prop="publicChain" class="publicChain">
        <template slot="label">
          <div class="publicChain-label">
            <div class="">
              公链
              <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content">选择公链</div>
                <i class="el-icon-warning"></i>
              </el-tooltip>
            </div>
            <!-- <div class="">
              <img src="" class="" alt="公链" />
            </div> -->
          </div>
        </template>
        <el-radio-group v-model="tokenForm.publicChain" @input="selectFunction">
          <el-radio
            v-for="(item, index) in tokenForm.publicChainOptions"
            :key="item.value"
            :label="item.name"
            :value="index"
            >{{ item.name }}</el-radio
          >
        </el-radio-group>
        <!-- <el-select
          v-model="tokenForm.publicChain"
          placeholder="请选择"
          :popper-append-to-body="false"
          :no-data-text="'暂无数据'"
          @change="selectFunction"
        >
          <el-option
            v-for="(item, index) in tokenForm.publicChainOptions"
            :key="item.value"
            :label="item.name"
            :value="index"
          >
          </el-option>
        </el-select> -->
      </el-form-item>

      <!-- <el-form-item label="RPC 节点" prop="node">
        <el-input v-model="tokenForm.node" :disabled="true"></el-input>
      </el-form-item> -->

      <el-form-item :label="'最新实时Gas Price '+tokenForm.time" prop="gasPrice" class="real-timePrice">
        <!-- <div class="real-timePrice-time">{{ tokenForm.time }}</div> -->
        <div class="real-timePrice-label">
          <i class="el-icon-odometer"></i> {{ tokenForm.symbol }} Gas Price
        </div>

        <div
          v-if="tokenForm.gasPrice"
          class="real-timePrice-gasPrice"
          type="success"
          >{{ tokenForm.gasPrice }} Gwei <i class="el-icon-refresh-right" @click="refreshPrice"></i></div>
          <!-- <i class="el-icon-refresh-right"  @click="refreshPrice"></i> -->
          
         

        <!-- <div class="real-timePrice-progress">
          <el-progress
            type="circle"
            :percentage="counter * 10"
            :stroke-width="12"
            :width="216"
            color="#67C23A"
          ></el-progress>
        </div> -->
      </el-form-item>
    </el-form>

    <!--   Loading   -->
    <LoadingAlert
      :visible.sync="showLoading"
      :LoadingText="LoadingText"
    ></LoadingAlert>
  </div>
</template>

<script>
import LoadingAlert from "@/components/alert/loading";
import { ethers } from "ethers";
import { nodeConfigs } from "@/config/config.js";
import * as XLSX from "xlsx";
export default {
  components: {
    LoadingAlert,
  },
  data() {
    return {
      tokenForm: {
        node: nodeConfigs[0].rpc, // 节点
        symbol: nodeConfigs[0].symbol,
        publicChain: nodeConfigs[0].name, // 公链下拉选择框
        publicChainOptions: nodeConfigs,

        time: this.getCurrentDateTime(),
        gasPrice: "",
      },
      tokenRules: {},

      counter: 0,
      timer: null,

      regex: /^[a-zA-Z0-9]{42}$/, // 正则判断
      provider: null,

      showLoading: false, // 遮罩层
      LoadingText: "",
    };
  },
  mounted() {
    // 使用Etherscan等公共节点创建一个provider
    this.provider = new ethers.providers.JsonRpcProvider(this.tokenForm.node);
    this.getGasPrice();
  },
  methods: {
    // 选择公链
    selectFunction(value) {
      console.log("selectFunction=", value);
      var data = this.tokenForm.publicChainOptions.filter(
        (item) => item.name == value
      );
      if (!data || data.length == 0) {
        return;
      }
      this.tokenForm.node = data[0].rpc;
      this.tokenForm.symbol = data[0].symbol;
      console.log(this.tokenForm.symbol, this.tokenForm.node);
      this.provider = new ethers.providers.JsonRpcProvider(this.tokenForm.node);
      this.showLoading = true;
      this.LoadingText =
        "正在查询 " + this.tokenForm.symbol + " Gas Price，请稍候...";
      this.getGasPrice();
    },
    async getGasPrice() {
      try {
        const gasPriceWei = await this.provider.getGasPrice();
        this.tokenForm.gasPrice = ethers.utils.formatUnits(gasPriceWei, "gwei");
        console.log(this.tokenForm.gasPrice);
        this.showLoading = false;
      } catch (error) {
        console.error("获取gas价格出错:", error);
      }
    },
    getCurrentDateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = this.padNumber(now.getMonth() + 1); // 月份是从0开始的
      const day = this.padNumber(now.getDate());
      const hours = this.padNumber(now.getHours());
      const minutes = this.padNumber(now.getMinutes());
      const seconds = this.padNumber(now.getSeconds());
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    padNumber(num) {
      return num < 10 ? "0" + num : num;
    },
    refreshPrice() {

      this.tokenForm.time = this.getCurrentDateTime();
       this.showLoading = true;
      this.LoadingText =
        "正在查询 " + this.tokenForm.symbol + " Gas Price，请稍候...";
      this.getGasPrice();

    },
  },
};
</script>

<style lang="scss" scoped>
.token-body {
  width: calc(100% - 30%);
  height: 100%;
  background: #1f1f1f;
  border-radius: 20px 20px 20px 20px;

  padding: 0 15% 0 15%;

  .token-form {
    width: 100%;
    margin: 20px 0 0 0;

    .token-title {
      font-weight: normal;
      font-size: 20px;
      color: #8f8f8f;
      line-height: 23px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin: 4% 0 0 0;
    }

    .token-node {
      font-weight: normal;
      font-size: 18px;
      color: #8f8f8f;
      line-height: 21px;
      text-align: center;
      font-style: normal;
      text-transform: none;

      margin: 54px 0 0 0;
    }

    /deep/.el-input__inner {
      height: 46px;

      background: #292929;
      border-radius: 4px 4px 4px 4px;
      border: none;

      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    /deep/.el-textarea__inner {
      background: #292929;
      border-radius: 4px 4px 4px 4px;
      border: none;

      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    /deep/.el-input__count {
      background: #292929;
      border-radius: 4px 4px 4px 4px;
      border: none;

      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    /deep/.el-form-item__label {
      font-weight: normal;
      font-size: 14px;
      color: #8f8f8f;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    /deep/.el-input-group__append {
      background: #3d3d3d;
      border-radius: 0px 4px 4px 0px;
      border: none;

      font-weight: normal;
      font-size: 16px;
      color: #939393;
      line-height: 19px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }

    /deep/.el-select-dropdown {
      width: 198px;
      // background: #d9d9d9;
      border-radius: 8px 8px 8px 8px;
      font-weight: 400;
      font-size: 14px;
      color: #8f8f8f;
      line-height: 16px;
      text-align: center;
      font-style: normal;
      text-transform: none;

      top: 65px !important;
    }
    /deep/.el-select-dropdown__item:hover {
      background: rgba(77, 77, 77, 0.5);
      color: #d8d8d8;
    }
    /deep/.el-select-dropdown__item.selected {
      color: #675aff;
    }
    /deep/.popper__arrow {
      left: 93px !important;
    }

    .publicChain {
      width: 100%;
      /deep/.el-form-item__label {
        width: 100% !important;
      }

      .publicChain-label {
        width: 100%;
        max-width: 215px;
        white-space: nowrap;

        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }

    .real-timePrice {
      font-weight: normal;
      text-align: left;
      font-style: normal;
      text-transform: none;

      .real-timePrice-label {
        font-size: 24px;
        color: #d8d8d8;
      }

      .real-timePrice-time {
        color: #bcbcbc;
        font-size: 14px;
      }

      .real-timePrice-gasPrice {
        font-size:30px;
        margin: 0 0 0px 0;
        // line-height: 50px;
        height: 50px;
        padding: 10px 0px;
        color: #675aff;
      }
      .el-icon-refresh-right{
        color: #ffffff;
        margin: 0 20px;
        font-size: 25px;
      }

      .real-timePrice-progress {
        text-align: center;
      }
    }
  }
}

/* 为所有滚动条设置样式 */
::-webkit-scrollbar {
  width: 6px; /* 设置滚动条的宽度 */
  height: 10px; /* 设置滚动条的高度 */
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background: transparent; /* 设置轨道的背景颜色 */
}

/* 滚动条的滑块 */
::-webkit-scrollbar-thumb {
  background: #888; /* 设置滑块的背景颜色 */
  border-radius: 5px 5px;
}

/* 当鼠标悬停在滑块上 */
::-webkit-scrollbar-thumb:hover {
  background: #555; /* 设置滑块在悬停状态下的背景颜色 */
  cursor: pointer;
}
</style>